import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories } from '@/mocks/data';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'slots');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activeSlug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug) || categories[0];

  return (
    <Layout>
      <Breadcrumb
        items={[
          { label: '首页', path: '/' },
          { label: '游戏分类', path: '/category/slots' },
          { label: currentCategory.name },
        ]}
      />
      <section className="w-full px-4 md:px-6 py-8 md:py-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
              {currentCategory.name}
            </h1>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              {currentCategory.description}
            </p>
          </div>

          <div className="flex items-center gap-2 overflow-x-auto pb-3 mb-8 flex-wrap justify-center">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 border border-background-200/70 text-foreground-600 hover:border-primary-200/60 hover:text-foreground-950'
                }`}
              >
                <i className={`${cat.icon} text-sm`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {currentCategory.games.map((game) => (
              <div
                key={game.id}
                className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={game.image}
                    alt={game.name}
                    title={`${game.name} - PG国际008`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-background-950/70 text-background-50 text-xs flex items-center gap-1">
                    <i className="ri-star-fill text-accent-400 text-xs"></i>
                    {game.rating}
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                    {game.name}
                  </h3>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400 flex items-center gap-1">
                      <i className="ri-user-line"></i>
                      {game.players} 在玩
                    </span>
                    <span className="px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium cursor-pointer hover:bg-primary-200 transition-colors">
                      开始游戏
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}